import { FormEvent, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { authApi } from '../../services/api';
import { AuthLayout, Fehlermeldung } from './AuthLayout';

export default function PasswortZuruecksetzenPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const [benutzerId, setBenutzerId] = useState(params.get('benutzer') ?? '');
  const [code, setCode] = useState(params.get('code') ?? '');
  const [passwort, setPasswort] = useState('');
  const [fehler, setFehler] = useState<unknown>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function absenden(e: FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLaeuft(true);
    try {
      await authApi.passwortZuruecksetzen({
        benutzer_id: Number(benutzerId),
        code,
        neues_passwort: passwort,
      });
      // Alle Sitzungen wurden serverseitig widerrufen -- deshalb geht es
      // zur Anmeldung und nicht direkt in die Anwendung.
      navigate('/login?zurueckgesetzt=1', { replace: true });
    } catch (err) {
      setFehler(err);
    } finally {
      setLaeuft(false);
    }
  }

  const eingabe =
    'mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500';

  return (
    <AuthLayout
      titel="Neues Passwort setzen"
      untertitel="Der Code aus der E-Mail gilt 10 Minuten."
      fusszeile={
        <Link to="/login" className="text-primary-600 hover:underline">
          Zurück zur Anmeldung
        </Link>
      }
    >
      <Fehlermeldung fehler={fehler} />

      <form onSubmit={absenden} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Benutzernummer</label>
          <input
            required
            inputMode="numeric"
            value={benutzerId}
            onChange={(e) => setBenutzerId(e.target.value.replace(/\D/g, ''))}
            className={eingabe}
          />
          <p className="mt-1 text-xs text-gray-500">Sie steht in der E-Mail.</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Code</label>
          <input
            required
            inputMode="numeric"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            className={eingabe}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Neues Passwort</label>
          <input
            type="password"
            required
            minLength={12}
            autoComplete="new-password"
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
            className={eingabe}
          />
        </div>

        <button
          type="submit"
          disabled={laeuft}
          className="flex w-full items-center justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-60"
        >
          {laeuft && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Passwort setzen
        </button>
      </form>
    </AuthLayout>
  );
}
